import { createFileRoute } from "@tanstack/react-router";
import { getCheckins } from "~/fetch/checkins";
import { CardsPage } from "~/components/CardsPage";

export const Route = createFileRoute('/location/city/$id/')({
  component: Component,
  loader: ({ params }) => {
    return getCheckins({ data: { page: 1, group: 'venue.location.city', groupValue: params.id } });
  },
});

function Component() {
  const data = Route.useLoaderData();
  return <CardsPage data={data} />;
}
